module.exports = __webpack_public_path__ + "static/media/autumn-che-big-mobile.39cb7e5d.png";